import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonItemOption, IonItemOptions, IonItemSliding, IonLabel, IonModal, IonTitle, IonToolbar } from '@ionic/react'
import { closeOutline, createOutline, trashOutline } from 'ionicons/icons'
import { FC, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startEquipoUpdated } from '../../../actions/equipos'
import { setActiveLoading, setCorrienteNominalEditHide, setCorrienteNominalEditShow } from '../../../actions/ui'
import { RootState } from '../../../reducers/rootReducer'

const initForm = {
  corrienteNominal: '',
}

export const CorrienteNominalItem: FC = () => {
  const dispatch = useDispatch();
  const { activeEquipo: { corrienteNominal } } = useSelector((state: RootState) => state.equipo);
  const { editCorrienteNominal } = useSelector((state: RootState) => state.ui);

  const handleDelete = () => {}
  const handleUpdate = () => {
    dispatch(setCorrienteNominalEditShow())

  }
  return (
    <IonItem>
      <IonLabel className="item-label" position="stacked" color="primary">
        Corriente Nominal
      </IonLabel>
      <IonItemSliding>
        <IonItem lines="none">
          <IonLabel>{corrienteNominal}</IonLabel>
          {editCorrienteNominal && <CorrienteNominalModal />}
        </IonItem>
        <IonItemOptions side="end" color="light">
          <IonItemOption color="light" onClick={() => { handleUpdate() }}><IonIcon className="icon-list" color="success" ariaLabel="Editar" title="Editar" icon={createOutline}></IonIcon></IonItemOption>
          <IonItemOption color="light" onClick={() => { handleDelete() }}><IonIcon className="icon-list" color="danger" icon={trashOutline}></IonIcon></IonItemOption>
        </IonItemOptions>
      </IonItemSliding>
    </IonItem>
  )
}

const CorrienteNominalModal: FC = () => {
  const dispatch = useDispatch();

  const { editCorrienteNominal } = useSelector((state: RootState) => state.ui);
  const { activeEquipo } = useSelector((state: RootState) => state.equipo);

  const [formValues, setFormValues] = useState(initForm);
  const { corrienteNominal } = formValues;
  useEffect(() => {
    if (activeEquipo.corrienteNominal) {
      const cn = {
        corrienteNominal: activeEquipo.corrienteNominal,
      };
      setFormValues(cn)
    } else {
      setFormValues(initForm)
    }
  }, [activeEquipo.corrienteNominal])

  const handleInputChange = ({ target }) => {
    setFormValues({
      ...formValues,
      [target.name]: target.value,
    });
  };

  const equipo = {
    tag: activeEquipo.tag,
    nombre_equipo: activeEquipo.nombre_equipo,
    descripcion_equipo: activeEquipo.descripcion_equipo,
    central: activeEquipo.central !== null ? activeEquipo.central._id : "",
    numero_equipo: activeEquipo.numero_equipo,
    type: activeEquipo.type,
    corrienteNominal: activeEquipo.corrienteNominal,

  };

  const handleUpdate = (e: any) => {
    e.preventDefault();
    dispatch(setActiveLoading());
    equipo.corrienteNominal = corrienteNominal
    dispatch(startEquipoUpdated(equipo));
    dispatch(setCorrienteNominalEditHide())
  };

  const handleClose = () => {
    dispatch(setCorrienteNominalEditHide());
  };
  return (
    <IonContent>
      <IonModal isOpen={editCorrienteNominal} cssClass='modal-unit-iput'>
        <IonHeader className="ion-no-border">
          <IonToolbar>
            <IonTitle color="dark">Corriente Nominal</IonTitle>
            <IonButtons slot="end">
              <IonButton color="primary" onClick={handleClose}>
                <IonIcon icon={closeOutline}></IonIcon>
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent className="marca-container">
          <form onSubmit={handleUpdate}>
            <IonItem lines="inset">
              <IonInput
                type="number"
                inputMode="numeric"
                name="corrienteNominal"
                value={corrienteNominal}
                onIonChange={handleInputChange}
                placeholder="Corriente nominal"
              ></IonInput>
            </IonItem>
            <IonItem lines="none">
              <IonButton slot="end" fill="clear" type="submit">
                Guardar
              </IonButton>
              <IonButton slot="end" fill="clear" onClick={handleClose}>
                Cancelar
              </IonButton>
            </IonItem>          
          </form>
        </IonContent>
      </IonModal>
    </IonContent>
  );
}
